module.exports = __webpack_public_path__ + "img/block_small.e0ce2a44.png";